import React, { useEffect, useState } from "react";
import Styles from "./TenderBox.module.css";
import Countdown from "../../../commons/CountDownTimer/Countdown";
import { Close, Done, ExpandMore, RemoveRedEye } from "@mui/icons-material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AirplayIcon from "@mui/icons-material/Airplay";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useNavigate } from "react-router-dom";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import {
  dateTimeSeperate,
  formatDateTimeView,
  formatDateType,
} from "../../../commons/FormatDate";
import {
  getDocument,
  getequisitionsBidders,
  getequisitionsList,
} from "../../../Services/ReverseAuction/GetApi";

import { useDispatch, useSelector } from "react-redux";
import PlaceBid from "../../Modals/ReverseAuction/PlaceBid/PlaceBid";
import ViewBids from "../../Modals/ReverseAuction/ViewBids/ViewBids";
import RaDocumentation from "../../Modals/ReverseAuction/RaDocumentation/RaDocumentation";
import GavelIcon from "@mui/icons-material/Gavel";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import { getTenderState } from "../../../commons/ReverseAuctionStatus";
import CreateTender from "../../Modals/ReverseAuction/CreateTender/CreateTender";
import ConfirmationModal from "../../../commons/ConfirmationModal/ConfirmationModal";
import {
  activateTender,
  approveQuantityRequest,
  handleRaFinalizeT_C,
  updateAuctionTender,
} from "../../../Services/ReverseAuction/AlterApi";
import SelectParticipant from "../../Modals/ReverseAuction/SelectParticipants/SelectParticipant";
import NotifyModal from "../../../commons/NotifyModal/NotifyModal";
import { usePdfPreview } from "../../../hooks/usePdfPreview";
import {
  ErrorMessage,
  SuccessMessage,
} from "../../../commons/Toast/ErrorMessage";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../commons/Accordion";
import { set } from "date-fns";
import { activeTenderId, auctionGet } from "../../../Redux/Slices/auctionSlice";
import OngoingRATable from "../../../pages/TokenAccess/Common/UnifiedLedgerOld/OngoingConnections/Ongoing_RA_Table";
import { activeType2Loading } from "../../../Redux/Slices/notificationSlice";
import { IconButton, Tooltip } from "@mui/material";
import { ReactComponent as InfoIcon } from "../../../assets/images/info.svg";

const TenderBox = ({
  data,
  reqExt,
  handleReq,
  getReqDetails,
  selectedBid,
  reqList,
  hoverId,
  handleHover,
  rfq,
}) => {
  const dispatch = useDispatch();
  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();
  const notify = useSelector((state) => state?.notificationSlice?.latest);
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  ).toLowerCase();
  let tenderData = data;
  const tenderTimeDate = {
    tenderNo: tenderData?.tenderNumber,
    tenderStartDateTime: tenderData?.tenderStartDateTime,
    tenderCloseDateTime: tenderData?.tenderCloseDateTime,
    bidStartDateTime: tenderData?.bidStartDateTime,
    bidCloseDateTime: tenderData?.bidCloseDateTime,
    auctionStartDateTime: tenderData?.auctionStartDateTime,
    auctionCloseDateTime: tenderData?.auctionCloseDateTime,
  };
  let status = (tenderData && getTenderState(tenderTimeDate, rfq)) || "na";
  console.debug("status", status);

  const navigate = useNavigate();

  const [viewBids, setViewBids] = useState([]);
  const [bidModal, setBidModal] = useState(false);

  const [placeBid, setPlaceBid] = useState(false);
  const [reqDetail, setReqDetail] = useState({});
  const [reqIndex, setReqIndex] = useState(null);

  // Edit
  const [editData, setEditData] = useState({});
  const [editModal, setEditModal] = useState(false);

  // Duplicate
  const [duplicate, setDuplicate] = useState(false);

  // Activate
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [confirmHeader, setConfirmHeader] = useState("");
  const [confirmNote, setConfirmNote] = useState("");

  //Review Bid
  const [bidConfirmation, setBidConfirmation] = useState({
    status: false,
    data: null,
    payload: null,
  });
  // Participants
  const [viewPartyModal, setViewPartyModal] = useState(false);

  // Notify Modal
  const [notifyModal, setNotifyModal] = useState(false);
  const [notifyType, setNotifyType] = useState("");
  const [notifyHeader, setNotifyHeader] = useState("");
  const [notifyText, setNotifyText] = useState("");

  // Settlement
  const [settlement, setSettlement] = useState(false);
  const [settlementBids, setSettlementBids] = useState([]);

  // Hover Id
  const [agreementModal, setAgreementModal] = useState({
    status: false,
    data: "",
    type: "",
  });

  const trader = useSelector((state) => state?.persistedReducer);

  const traderParent = trader?.roles?.includes("TRADER");
  const userId = trader?.user?.user?.userId;

  const viewRightButtons = traderParent
    ? userId === tenderData?.traderAssigned
    : tenderData?.traderAssigned === 0;

  useEffect(() => {
    if (notify?.key === "BSRANotifyConsumerBidUpdated" && role === "consumer") {
      if (placeBid && notify?.data?.tenderNumber === tenderData?.tenderNumber) {
        handleViewBids(reqList[reqIndex]?.bids, reqList[reqIndex], reqIndex);
      }
    }
  }, [notify, reqList]);

  const handleAcceptRequest = async (id, val) => {
    let payload = {
      bidIdToStatusMap: {
        [id]: val, //bidId to amount map
      },
    };
    let res = await approveQuantityRequest(payload);
    if (res?.data?.code === 200) {
      setBidConfirmation({
        status: false,
        data: null,
        payload: null,
      });
      SuccessMessage(res?.data?.message);
      window.location.reload();
    }
  };

  const handlePlaceBid = (requsition) => {
    setReqDetail(requsition);
    setPlaceBid(true);
  };

  const handleViewBids = (data, requsition, index) => {
    console.debug("gna1", data, requsition, index);
    setReqDetail(requsition);
    setViewBids(data);
    setPlaceBid(true);
    setReqIndex(index);
  };

  const handleNav = (nav) => {
    navigate(nav);
  };

  const handleDuplicate = () => {
    setDuplicate(true);
    handleEdit("duplicate");
  };

  const handleRequisition = () => {
    handleReq(status, tenderData?.id, "", false);
  };

  const handleEdit = async (type) => {
    let data = {
      id: type === "duplicate" ? null : tenderData?.id,
      capacityId: tenderData?.capacityId,
      requisitions: await getReqDetails(
        status,
        tenderData?.id,
        "edit_case",
        false,
      ),
      tenderStartDate: dateTimeSeperate(tenderData?.tenderStartDateTime)?.date,
      tenderEndDate: dateTimeSeperate(tenderData?.tenderCloseDateTime)?.date,
      tenderStartTime: dateTimeSeperate(tenderData?.tenderStartDateTime)?.time,
      tenderEndTime: dateTimeSeperate(tenderData?.tenderCloseDateTime)?.time,
      biddingStartDate: dateTimeSeperate(tenderData?.bidStartDateTime)?.date,
      biddingEndDate: dateTimeSeperate(tenderData?.bidCloseDateTime)?.date,
      biddingStartTime: dateTimeSeperate(tenderData?.bidStartDateTime)?.time,
      biddingEndTime: dateTimeSeperate(tenderData?.bidCloseDateTime)?.time,
      reverseAuctionStartDate:
        !rfq && dateTimeSeperate(tenderData?.auctionStartDateTime)?.date,
      reverseAuctionEndDate:
        !rfq && dateTimeSeperate(tenderData?.auctionCloseDateTime)?.date,
      reverseAuctionStartTime:
        !rfq && dateTimeSeperate(tenderData?.auctionStartDateTime)?.time,
      reverseAuctionEndTime:
        !rfq && dateTimeSeperate(tenderData?.auctionCloseDateTime)?.time,
      initialMargin: tenderData?.initialMarginPercent,
      Emd: tenderData?.emdPerMw,
      minQty: tenderData?.minQtyPerDay,
      paymentSecurity: tenderData?.paymentSecurityDays,
      comment: tenderData?.comments,
      generalTC: tenderData?.tenderDoc,
      auctionType: tenderData?.auctionType,
      auctionParticipants:
        tenderData?.auctionParticipants?.map((p) => p.generatorId) || [],
      comments: tenderData?.comments,
    };
    setEditData(data);
    setTimeout(() => {
      setEditModal(true);
    }, 2000);
  };

  const handleActivateModal = () => {
    setConfirmText(`Do you want to Activate this tender?`);
    setConfirmNote(`'Edit Tender' will be blocked after activation.`);
    setConfirmHeader("Activate Tender");
    setConfirmModal(true);
  };

  const handleActivate = async () => {
    dispatch(activeType2Loading(true));
    setConfirmModal(false);
    let tenderPayload = {};
    let res = await activateTender(tenderPayload, tenderData?.id);
    if (res?.data?.code === 200) {
      setConfirmModal(false);
      dispatch(auctionGet());
      dispatch(activeType2Loading(false));
      window.location.reload();
    } else {
      dispatch(activeType2Loading(false));
    }
  };

  const handleUpdate = (id) => {
    getReqDetails(status, tenderData?.id, "", false);
  };

  const handleNotifyModal = (type, header, data) => {
    setNotifyHeader(header);
    setNotifyText(data);
    setNotifyType(type);
    setNotifyModal(true);
  };

  const handleNavClick = (type, nav) => {
    if (type === "TENDER") {
      if (role === "consumer") {
        handleNav(`/bidding?id=${tenderData?.id}`);
        return;
      }
      if (status?.includes("cb_ongoing")) {
        handleNav(`/bidding?id=${tenderData?.id}`);
      } else {
        handleNotifyModal(
          type,
          "Tender Not Open Yet",
          "This tender isn’t open for viewing bids yet. Click Notify Me to set a reminder, and we’ll alert you once it opens.",
        );
      }
    } else if (type === "BID") {
      if (status?.includes("cb_ongoing")) {
        handleNav(`/bidding?id=${tenderData?.id}`);
      } else {
        handleNotifyModal(
          type,
          "Bidding Not Started Yet",
          "This tender isn’t open for viewing bids yet. Click Notify Me to set a reminder, and we’ll alert you once it opens.",
        );
      }
    } else if (type === "AUCTION") {
      if (status?.includes("ra_ongoing")) {
        handleNav(`/live_auction?id=${tenderData?.id}`);
      } else {
        handleNotifyModal(
          type,
          "Tender Not Open Yet",
          "This tender isn’t open for viewing bids yet. Click Notify Me to set a reminder, and we’ll alert you once it opens.",
        );
      }
    } else if (type === "TERMS") {
      if (status?.includes("tender_closing_soon")) {
        if (
          tenderData?.tenderStatus === "BUCKET_FILLED_RA" ||
          tenderData?.tenderStatus === "BUCKET_FILLED"
        ) {
          handleSettlement();
        } else {
          dispatch(activeTenderId(tenderData?.id));
          localStorage.setItem("activetenderId", tenderData?.id);
          if (role === "consumer") {
            handleNav(`/tender_active?id=${tenderData?.capacityId}`);
          } else {
            handleNav(`/tender_active?id=${tenderData?.generatorCapacityId}`);
          }
        }
      } else {
        handleNotifyModal(
          type,
          "Tender Not Open Yet",
          "This tender isn’t open for viewing bids yet. Click Notify Me to set a reminder, and we’ll alert you once it opens.",
        );
      }
    }
    // else if (type === "SCHEDULE") {
    //   if (tenderData?.tenderStatus === "TERMS") {
    //     handleNav(`/tender_ongoing?id=${tenderData?.id}`);
    //   } else {
    //     handleNotifyModal(
    //       type,
    //       "Tender Not Open Yet",
    //       "This tender isn’t open for viewing bids yet. Click Notify Me to set a reminder, and we’ll alert you once it opens."
    //     );
    //   }
    // }
    else {
      handleNav(nav);
    }
  };

  const handleSettlement = async () => {
    let res = await getequisitionsList(tenderData?.id, rfq ? "CB" : "AUCTION");
    if (res?.data?.code === 200) {
      const pendingBids = res?.data?.data.flatMap(
        (req) =>
          req.bids?.filter((bid) => bid.winnerBidStatus === "PENDING") || [],
      );
      if (pendingBids?.length > 0) {
        setConfirmNote(
          `There are ${pendingBids?.length} bid(s) requests currently in a pending state. Once finalized, the bids will be removed.`,
        );
      }
      let bids = res?.data?.data
        .flatMap(
          (req) =>
            req.bids?.filter((bid) => bid.winnerBidStatus === "ACCEPTED") || [],
        )
        .map((bid) => bid.id);
      setSettlementBids(bids);
      setSettlement(true);
      setConfirmText(`Do you want to Finalization?`);
      setConfirmHeader("Finalization");
      setConfirmNote(`Initial Margin will be blocked as per System T&C.`);
      setAgreementModal({
        status: true,
        data: res?.data?.data,
        type: "Auction",
      });
    }
  };

  const handleFinalizeT_C = async (bids) => {
    dispatch(activeType2Loading(true));
    setConfirmModal(false);
    let payload = {
      selectedBidIds: bids,
      tenderId: tenderData?.id,
      bidStage: status?.includes("ra_ongoing") ? "AUCTION" : "CB",
    };
    console.debug(payload);
    let res = await handleRaFinalizeT_C(payload);
    if (res?.data?.code === 200) {
      setAgreementModal({ status: false, data: "", type: "" });
      SuccessMessage(res?.data?.message);
      localStorage.setItem("activetenderId", tenderData?.id);
      dispatch(activeTenderId(tenderData?.id));
      if (role === "consumer") {
        navigate(`/tender_active?id=${tenderData?.capacityId}`);
      }
      dispatch(activeType2Loading(false));
    } else {
      dispatch(activeType2Loading(false));
      ErrorMessage(
        res?.data?.message || res?.data?.error || "Something went wrong",
      );
    }
  };

  const handleSubmitAgreement = () => {
    setConfirmModal(true);
  };

  const handleDownload = async () => {
    const response = await getDocument(tenderData?.id);
    const blob = response.data;
    if (!blob) return;
    const url = window.URL.createObjectURL(
      new Blob([blob], {
        type: "application/pdf",
      }),
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `tender_${tenderData?.id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    SuccessMessage("Listing downloaded successfully!");
  };

  return (
    <>
      {agreementModal?.status && (
        <RaDocumentation
          open={agreementModal?.status}
          handleClose={() =>
            setAgreementModal({ status: false, data: "", type: "" })
          }
          data={agreementModal}
          handleSubmit={handleFinalizeT_C}
          tenderData={tenderData}
          rfq={rfq}
        />
      )}
      <OngoingRATable tenderData={tenderData} />
      <PdfPreviewModal />
      {notifyModal && (
        <NotifyModal
          open={notifyModal}
          handleClose={() => setNotifyModal(false)}
          type={notifyType}
          header={notifyHeader}
          text={notifyText}
        />
      )}
      {viewPartyModal && (
        <SelectParticipant
          open={viewPartyModal}
          handleClose={() => setViewPartyModal(false)}
          list={tenderData?.auctionParticipants}
          type={"view"}
          header={"View Participants"}
        />
      )}
      {bidConfirmation?.status && (
        <ConfirmationModal
          open={bidConfirmation?.status}
          handleClose={() => {
            setBidConfirmation({
              status: false,
              data: null,
              payload: null,
            });
          }}
          data={bidConfirmation?.data}
          header={"Bid Confirmation"}
          handleSubmit={() =>
            handleAcceptRequest(
              bidConfirmation?.payload?.bidId,
              bidConfirmation?.payload?.action,
            )
          }
        />
      )}
      {confirmModal && (
        <ConfirmationModal
          open={confirmModal}
          handleClose={() => setConfirmModal(false)}
          data={confirmText}
          header={confirmHeader}
          note={confirmNote}
          handleSubmit={settlement ? handleFinalizeT_C : handleActivate}
        />
      )}
      {editModal && (
        <CreateTender
          open={editModal}
          handleClose={() => {
            setEditModal(false);
            setDuplicate(false);
          }}
          type={"edit"}
          editData={editData}
          duplicate={duplicate}
          priceDiscoveryType={"RA"}
          rfq={rfq}
        />
      )}
      {bidModal && (
        <ViewBids
          open={bidModal}
          handleClose={() => setBidModal(false)}
          data={viewBids}
        />
      )}
      {placeBid && (
        <PlaceBid
          open={placeBid}
          handleClose={() => setPlaceBid(false)}
          tenderData={tenderData}
          requisitionData={reqDetail}
          bidStage={
            status.includes("ra_ongoing") ||
            status.includes("tender_closing_soon") ||
            status.includes("closed")
              ? "AUCTION"
              : "CB"
          }
          handleUpdate={handleUpdate}
          status={status}
          viewBids={viewBids}
        />
      )}
      <div
        className={`${Styles.tenderBoxMain} ${
          hoverId === tenderData?.id || reqExt === tenderData?.id
            ? Styles.tenderBoxMainHover
            : ""
        }`}
        onMouseEnter={() => handleHover(tenderData?.id)}
        onMouseLeave={() => handleHover("")}
      >
        <div className={`display_flex_row ${Styles.CountdownContainer}`}>
          <div className="display_flex_row_gap_8_only" style={{ gap: "32px" }}>
            {role === "generator" && (
              <div
                className={`display_flex_column_gap_4 ${Styles.tenderHadingDetails}`}
              >
                <div>Name</div>
                <div>{tenderData?.consumerName}</div>
              </div>
            )}
            <div
              className={`display_flex_column_gap_4 ${Styles.tenderHadingDetails}`}
            >
              <div>E:Tender Number:</div>
              <div>{tenderData?.tenderNumber}</div>
            </div>
            {!rfq && (
              <div
                className={`display_flex_column_gap_4 ${Styles.tenderHadingDetails}`}
              >
                <div>E:RA Number:</div>
                <div>{tenderData?.auctionNumber}</div>
              </div>
            )}
          </div>
          <div>
            {tenderData?.tenderStatus === "TERMINATED" ? (
              <div className="rejected">Tender Terminated</div>
            ) : status?.includes("closed") ? (
              <div className="rejected">Tender Ended</div>
            ) : tenderData?.tenderStatus === "DRAFT" && viewRightButtons ? (
              <div
                className={`activeButton_type_2 ${Styles.activate_button}`}
                onClick={handleActivateModal}
              >
                Activate Tender
              </div>
            ) : (
              <>
                {status && tenderData && (
                  <Countdown
                    status={status}
                    tenderData={tenderData}
                    extended={tenderData?.requisitionAuctionWindow?.length > 0}
                  />
                )}
              </>
            )}
          </div>
        </div>
        <div className={Styles.tenderBoxMiddle}>
          <Accordion
            key={tenderData?.id}
            expanded={reqExt === tenderData?.id}
            onChange={() => handleRequisition()}
          >
            <AccordionSummary>
              <>
                <div
                  className={`display_flex_row ${Styles.tenderDetailsContainer}`}
                >
                  <div
                    className={`display_flex_column_gap_4 ${Styles.tenderDetails}`}
                  >
                    <div>Tender Duration</div>
                    <div>
                      {formatDateTimeView(tenderData?.tenderStartDateTime)} to{" "}
                      {formatDateTimeView(tenderData?.tenderCloseDateTime)}
                    </div>
                  </div>
                  <div
                    className={`display_flex_column_gap_4 ${Styles.tenderDetails}`}
                  >
                    <div>Bidding Duration</div>
                    <div>
                      {formatDateTimeView(tenderData?.bidStartDateTime)} to{" "}
                      {formatDateTimeView(tenderData?.bidCloseDateTime)}
                    </div>
                  </div>
                  {!rfq && (
                    <div
                      className={`display_flex_column_gap_4 ${Styles.tenderDetails}`}
                    >
                      <div>Reverse Auction Duration</div>
                      <div>
                        {formatDateTimeView(tenderData?.auctionStartDateTime)}{" "}
                        to{" "}
                        {formatDateTimeView(tenderData?.auctionCloseDateTime)}
                      </div>
                    </div>
                  )}
                  <div
                    className={`display_flex_column_gap_4 ${Styles.tenderDetails}`}
                  >
                    <div>EMD (₹/MW)</div>
                    <div>{tenderData?.emdPerMw}</div>
                  </div>
                </div>
                {reqExt !== tenderData?.id && (
                  <div
                    className={`display_flex_row_gap_8 ${Styles.viewRequestions}`}
                    onClick={() => handleRequisition()}
                  >
                    <span>
                      {reqExt === tenderData?.id ? "Hide" : "View All"}{" "}
                      Requisition
                    </span>
                    <ExpandMore
                      style={{ fontSize: "12px" }}
                      className={
                        reqExt === tenderData?.id ? Styles.iconExpanded : ""
                      }
                    />
                  </div>
                )}
              </>
            </AccordionSummary>
            <AccordionDetails>
              <>
                {reqList?.length > 0 && (
                  <div
                    className={`${Styles.reqExtContainer} ${
                      reqExt === tenderData?.id &&
                      Styles.reqExtContainerExtension
                    }`}
                  >
                    <div className={Styles.reqMainTable}>
                      <div className={`display_flex_row tableHeading`}>
                        <div style={{ width: "5%" }}>Sl. No.</div>
                        <div style={{ width: "20%" }}>Start & End Date</div>
                        <div style={{ width: "10%" }}>Start & End Time</div>
                        <div style={{ width: "10%" }}>Req. Qty (MW)</div>
                        <div style={{ width: "10%" }}>Min. Qty (MW)</div>
                        <div style={{ width: "20%" }}>
                          {role === "consumer" ? "Lowest Bid" : "Self Bid"}
                        </div>
                        {role === "generator" &&
                          status?.includes("tender_closing_soon") && (
                            <div style={{ width: "15%" }}>
                              {tenderData?.tenderStatus === "TERMS"
                                ? "Allocated"
                                : "Proposed"}{" "}
                              Qty (MW)
                              {tenderData?.tenderStatus !== "TERMS" && (
                                <Tooltip
                                  title={
                                    <span style={{ whiteSpace: "pre-line" }}>
                                      The <b>Proposed Quantity</b> refers to the
                                      quantity submitted by the buyer that is
                                      below the minimum quantity stipulated in
                                      the RFP/RFQ. Such deviations require
                                      approval from the seller.
                                    </span>
                                  }
                                >
                                  <IconButton>
                                    <InfoIcon
                                      style={{ width: "14px", height: "16px" }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </div>
                          )}

                        <div style={{ width: "8%" }}>
                          {role === "consumer"
                            ? "View"
                            : (status.includes("cb_ongoing") ||
                                  status.includes("ra_ongoing")) &&
                                !status?.includes("tender_closing_soon")
                              ? "Activity"
                              : "Status"}
                        </div>
                      </div>
                      <div
                        className={`scroll_bar_y ${Styles.reqMainTableBody}`}
                      >
                        {reqList?.map((ele, index) => (
                          <div
                            className={`display_flex_row tableDetails ${Styles.reqCont}`}
                          >
                            <div style={{ width: "5%" }}>{index + 1}</div>
                            <div style={{ width: "20%" }}>
                              {`${formatDateType(
                                ele?.dateStartAt,
                              )} to ${formatDateType(ele?.dateEndAt)}`}
                            </div>
                            <div style={{ width: "10%" }}>
                              {ele?.slotStartAt} to{" "}
                              {ele?.slotEndAt === "23:59"
                                ? "24:00"
                                : ele?.slotEndAt}
                            </div>
                            <div style={{ width: "10%" }}>
                              {ele?.requiredQty ||
                                ele?.purchaseEnergy ||
                                ele?.sellEnergy}
                            </div>
                            <div style={{ width: "10%" }}>
                              {ele?.minimumQty}
                            </div>
                            <div style={{ width: "20%" }}>
                              {role === "consumer" && ele?.lowestBidPrice ? (
                                <div>
                                  {ele?.lowestBidPrice}
                                  (₹/kWh)
                                </div>
                              ) : role === "generator" && ele?.selfBid ? (
                                <div>
                                  {ele?.selfBid?.bidQuantityMw}(MW)/
                                  {ele?.selfBid?.bidPrice}(₹/kWh)
                                </div>
                              ) : (
                                <>-</>
                              )}
                            </div>
                            {role === "generator" &&
                              status?.includes("tender_closing_soon") && (
                                <div style={{ width: "15%" }}>
                                  {role === "consumer" &&
                                  ele?.lowestBidPrice ? (
                                    <div>{ele?.selectedQuantity}</div>
                                  ) : role === "generator" && ele?.selfBid ? (
                                    <div>
                                      {tenderData?.tenderStatus === "TERMS" ? (
                                        <>{ele?.selfBid?.selectedQuantity}</>
                                      ) : ele?.selfBid?.winnerBidStatus ===
                                        "PENDING" ? (
                                        <>{ele?.selfBid?.requestedQuantity}</>
                                      ) : ele?.selfBid?.winnerBidStatus ===
                                        "REJECTED" ? (
                                        "0"
                                      ) : (
                                        <>
                                          {ele?.selfBid?.requestedQuantity ||
                                            "-"}
                                        </>
                                      )}
                                      {/* {tenderData?.tenderStatus === "TERMS" &&
                                      ele?.selfBid?.winnerBidStatus !==
                                        "REJECTED" ? (
                                        <>
                                          {ele?.selfBid?.requestedQuantity ||
                                            ele?.selfBid?.selectedQuantity ||
                                            ele?.selfBid?.bidQuantityMw}
                                        </>
                                      ) : ele?.selfBid?.winnerBidStatus ===
                                        "PENDING" ? (
                                        <>
                                          {ele?.selfBid?.requestedQuantity ||
                                            ele?.selfBid?.selectedQuantity ||
                                            ele?.selfBid?.bidQuantityMw}
                                        </>
                                      ) : (
                                        <>
                                          {ele?.selfBid?.winnerBidStatus ===
                                          "REJECTED"
                                            ? "0"
                                            : "-"}
                                        </>
                                      )} */}
                                    </div>
                                  ) : (
                                    <>-</>
                                  )}
                                </div>
                              )}

                            <div style={{ width: "8%" }}>
                              {role === "consumer" ? (
                                <>
                                  {console.debug("status", status)}
                                  {status.includes("cb_ongoing") ||
                                  status?.includes("tender_closing_soon") ? (
                                    <div
                                      // className={`activeButton_type_2 ${Styles.bidButtons}`}
                                      onClick={() =>
                                        handleViewBids(ele?.bids, ele, index)
                                      }
                                    >
                                      <RemoveRedEye
                                        style={{
                                          fontSize: "12px",
                                          color: "#f1935c",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <>-</>
                                  )}
                                </>
                              ) : (
                                <>
                                  {status?.includes("tender_closing_soon") ? (
                                    <>
                                      {tenderData?.tenderStatus === "TERMS" ? (
                                        <div
                                          className={`${
                                            ele?.selfBid?.winnerBidStatus ===
                                              "ACCEPTED" ||
                                            ele?.selfBid?.winnerBidStatus ===
                                              "ALLOTED" ||
                                            ele?.selfBid?.bidStatus ===
                                              "AWARDED" ||
                                            ele?.selfBid?.winnerBidStatus ===
                                              "AWARDED"
                                              ? "accepted"
                                              : ele?.selfBid
                                                    ?.winnerBidStatus ===
                                                  "PENDING"
                                                ? "pending"
                                                : "rejected"
                                          }`}
                                        >
                                          {ele?.selfBid?.winnerBidStatus ===
                                          "REJECTED" ? (
                                            "Rejected"
                                          ) : ele?.selfBid?.winnerBidStatus ===
                                            "ACCEPTED" ? (
                                            "Submitted"
                                          ) : ele?.selfBid?.winnerBidStatus ===
                                            "AWARDED" ? (
                                            "Allotted"
                                          ) : ele?.selfBid?.winnerBidStatus ===
                                            "ALLOTED" ? (
                                            "Allotted"
                                          ) : ele?.selfBid?.bidStatus ===
                                            "REJECTED" ? (
                                            "Rejected"
                                          ) : ele?.selfBid?.winnerBidStatus ===
                                            "WITHDRAWN" ? (
                                            "Withdrawn"
                                          ) : ele?.selfBid?.winnerBidStatus ===
                                            "PENDING" ? (
                                            <div
                                              className={`display_flex_row_gap_8 ${Styles.bidAlterButtonCont}`}
                                            >
                                              <div
                                                className={Styles.rejectBtn}
                                                onClick={() =>
                                                  handleAcceptRequest(
                                                    ele?.selfBid?.id,
                                                    "WITHDRAWN",
                                                  )
                                                }
                                              >
                                                <Close
                                                  style={{ fontSize: "16px" }}
                                                />
                                              </div>
                                              <div
                                                className={Styles.acceptBtn}
                                                onClick={() =>
                                                  handleAcceptRequest(
                                                    ele?.selfBid?.id,
                                                    "ACCEPTED",
                                                  )
                                                }
                                              >
                                                <Done
                                                  style={{ fontSize: "16px" }}
                                                />
                                              </div>
                                            </div>
                                          ) : (
                                            "-"
                                          )}
                                        </div>
                                      ) : ele?.selfBid?.winnerBidStatus ===
                                        "PENDING" ? (
                                        <div
                                          className={`display_flex_row_gap_8 ${Styles.bidAlterButtonCont}`}
                                        >
                                          <div
                                            className={Styles.rejectBtn}
                                            onClick={() =>
                                              setBidConfirmation({
                                                status: true,
                                                data: "Are you sure you want to withdraw the bid request?",
                                                payload: {
                                                  bidId: ele?.selfBid?.id,
                                                  action: "WITHDRAWN",
                                                },
                                              })
                                            }
                                          >
                                            <Close
                                              style={{ fontSize: "16px" }}
                                            />
                                          </div>
                                          <div
                                            className={Styles.acceptBtn}
                                            onClick={() =>
                                              setBidConfirmation({
                                                status: true,
                                                data: "Are you sure you want to accept the bid request?",
                                                payload: {
                                                  bidId: ele?.selfBid?.id,
                                                  action: "ACCEPTED",
                                                },
                                              })
                                            }
                                          >
                                            <Done
                                              style={{ fontSize: "16px" }}
                                            />
                                          </div>
                                        </div>
                                      ) : (
                                        <>-</>
                                      )}
                                    </>
                                  ) : (status.includes("ra_ongoing") &&
                                      ele?.selfBid) ||
                                    (status.includes("cb_ongoing") &&
                                      !status.includes("ra_ongoing")) ? (
                                    <>
                                      {rfq ||
                                      new Date() <
                                        new Date(
                                          tenderData?.originalAuctionCloseDateTime,
                                        ) ||
                                      tenderData?.requisitionAuctionWindow?.filter(
                                        (ext) => ext?.requisitionId === ele?.id,
                                      )?.length > 0 ? (
                                        <>
                                          <div
                                            className={`activeButton_type_2 ${Styles.bidButtons}`}
                                            onClick={() => handlePlaceBid(ele)}
                                          >
                                            {ele?.selfBid
                                              ? "Edit Bid"
                                              : "Place Bids"}
                                          </div>
                                        </>
                                      ) : (
                                        <div
                                          style={{
                                            fontSize: "8px",
                                            color: "#34656d",
                                          }}
                                        >
                                          <b>Auction Ended</b> for this
                                          Requisition
                                        </div>
                                      )}
                                      {/* {
                                      tenderData?.requisitionAuctionWindow?.filter((ext)=>ext?.requisitionId === ele?.id)?.length > 0 ? <></>:<
                                    } */}
                                    </>
                                  ) : (
                                    <div
                                      className={
                                        ele?.selfBid?.bidStatus ===
                                        "SHORTLISTED"
                                          ? "accepted"
                                          : "rejected"
                                      }
                                    >
                                      {ele?.selfBid?.bidStatus === "SHORTLISTED"
                                        ? "Shortlisted"
                                        : ele?.selfBid?.bidStatus ===
                                              "REJECTED" ||
                                            (ele?.selfBid?.bidStatus ===
                                              "PLACED" &&
                                              ele?.selfBid?.bidStage ===
                                                "CB") ||
                                            (!ele?.selfBid &&
                                              (status.includes("cb_ongoing") ||
                                                status.includes("ra_ongoing")))
                                          ? "Rejected"
                                          : "-"}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                {reqExt === tenderData?.id && reqList?.length > 0 && (
                  <div
                    className={`display_flex_row_gap_8 ${Styles.hideRequestions}`}
                    onClick={() => handleRequisition()}
                  >
                    <span>
                      {reqExt === tenderData?.id ? "Hide" : "View All"}{" "}
                      Requisition
                    </span>
                    <ExpandMore
                      style={{ fontSize: "12px" }}
                      className={
                        reqExt === tenderData?.id ? Styles.iconExpanded : ""
                      }
                    />
                  </div>
                )}
              </>
            </AccordionDetails>
          </Accordion>
        </div>
        {tenderData?.comments && (
          <div className={Styles.commentContainer}>
            <div>Comment:</div>
            <div>{tenderData?.comments}</div>
          </div>
        )}
        <div className={`display_flex_row ${Styles.CountdownContainer}`}>
          <div className="display_flex_row_gap_8_only" style={{ gap: "16px" }}>
            {tenderData?.tenderDoc && (
              <div
                className={`display_flex_row_center ${Styles.generalT_CText}`}
                onClick={() => {
                  handlePreviewGeneralTerms(tenderData?.tenderDoc);
                }}
              >
                <span>General T&C</span>
                <ArrowOutwardIcon
                  style={{ fontSize: "12px", marginTop: "-15px" }}
                />
              </div>
            )}
            {role === "consumer" && (
              <div
                className={`display_flex_row_gap_8_only ${Styles.tenderHadingDetails}`}
              >
                <div>{rfq ? "Tender" : "Auction"} Type:</div>
                {rfq ? (
                  <div>
                    {tenderData?.auctionType === "CLOSED"
                      ? "Intrastate"
                      : "Interstate"}
                  </div>
                ) : (
                  <div>{tenderData?.auctionType}</div>
                )}
              </div>
            )}
            {role === "consumer" &&
              tenderData?.auctionParticipants?.length > 0 &&
              !rfq && (
                <div
                  className={`display_flex_row_gap_8_only ${Styles.tenderHadingDetails}`}
                >
                  <div>Invited Participants</div>
                  <div className="display_flex_row_gap_4_only">
                    <span>{tenderData?.auctionParticipants?.length}</span>
                    <RemoveRedEye
                      onClick={() => setViewPartyModal(true)}
                      style={{ fontSize: "12px", color: "#f1935c" }}
                    />
                  </div>
                </div>
              )}
          </div>
          {(viewRightButtons || role === "generator") && (
            <>
              <div
                className={`display_flex_row_gap_8_only ${Styles.buttonMainContianer}`}
              >
                {/* hoverId === tenderData?.id */}

                {role === "consumer" &&
                  tenderData?.tenderStatus === "DRAFT" &&
                  status?.length === 1 &&
                  status?.includes("upcoming") && (
                    <div
                      className={
                        (hoverId === tenderData?.id ||
                          reqExt === tenderData?.id) &&
                        Styles.buttonContainer
                      }
                      onClick={() => handleEdit()}
                    >
                      <BorderColorIcon style={{ fontSize: "14px" }} />
                      <div>Edit</div>
                    </div>
                  )}
                <div
                  className={
                    (hoverId === tenderData?.id || reqExt === tenderData?.id) &&
                    Styles.buttonContainer
                  }
                  onClick={handleDownload}
                >
                  <SaveAltIcon style={{ fontSize: "14px" }} />
                  <div>Download</div>
                </div>
                {/* {(process.env.REACT_APP_ENV === "qa" ||
              process.env.REACT_APP_ENV === "stage") && (
              <>
                {role === "consumer" &&
                  tenderData?.tenderStatus === "DRAFT" &&
                  status?.length === 1 &&
                  status?.includes("upcoming") && (
                    <div
                      className={
                        (hoverId === tenderData?.id ||
                          reqExt === tenderData?.id) &&
                        Styles.buttonContainer
                      }
                      onClick={handleDuplicate}
                    >
                      <ContentCopyIcon style={{ fontSize: "14px" }} />
                      <div>Duplicate</div>
                    </div>
                  )}
              </>
            )} */}
                {role === "consumer" && (
                  <>
                    {status?.includes("closed") &&
                    tenderData?.tenderStatus === "TERMS" ? (
                      <div
                        className={
                          (hoverId === tenderData?.id ||
                            reqExt === tenderData?.id) &&
                          Styles.buttonContainer
                        }
                        onClick={() => handleNavClick("TERMS")}
                      >
                        <DriveFileMoveIcon style={{ fontSize: "14px" }} />
                        <div>Schedule</div>
                      </div>
                    ) : status?.includes("tender_closing_soon") &&
                      !status?.includes("closed") ? (
                      <>
                        <div
                          className={
                            (hoverId === tenderData?.id ||
                              reqExt === tenderData?.id) &&
                            Styles.buttonContainer
                          }
                          onClick={() => handleNavClick("TERMS")}
                        >
                          <DriveFileMoveIcon style={{ fontSize: "14px" }} />
                          <div>Documentation</div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                )}
                {role === "generator" && (
                  <>
                    {status?.includes("tender_closing_soon") &&
                    tenderData?.tenderStatus === "TERMS" &&
                    !status?.includes("closed") ? (
                      <div
                        className={
                          (hoverId === tenderData?.id ||
                            reqExt === tenderData?.id) &&
                          Styles.buttonContainer
                        }
                        onClick={() => handleNavClick("TERMS")}
                      >
                        <DriveFileMoveIcon style={{ fontSize: "14px" }} />
                        <div>Agremeent</div>
                      </div>
                    ) : tenderData?.tenderStatus === "TERMS" &&
                      status?.includes("closed") ? (
                      <div
                        className={
                          (hoverId === tenderData?.id ||
                            reqExt === tenderData?.id) &&
                          Styles.buttonContainer
                        }
                        onClick={() => handleNavClick("TERMS")}
                      >
                        <DriveFileMoveIcon style={{ fontSize: "14px" }} />
                        <div>Schedule</div>
                      </div>
                    ) : status?.includes("ra_ongoing") ? (
                      <></>
                    ) : status?.includes("cb_ongoing") ? (
                      <></>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default TenderBox;
